export default "__VITE_ASSET__BMvQDBY$__"